import { api } from './client';
import type { Page } from './catalogs';

// Migration Quarantine (2026-06-06): карантин брудних даних з 1С.

export interface QuarantineIssue {
  field: string;
  rule: string;
  current_value: string | null;
  expected: string;
  message_uk: string;
  fix_hint_uk: string;
}

export interface QuarantineContractor {
  entity_id: string;
  contractor_code: string | null;
  contractor_name: string | null;
  issues: QuarantineIssue[];
  resolved: boolean;
  created_at: string;
  updated_at: string;
}

export interface QuarantineSummary {
  unresolved: number;
}

export const quarantine = {
  contractors: (params?: {
    include_resolved?: boolean;
    limit?: number;
    offset?: number;
  }) =>
    api
      .get<Page<QuarantineContractor>>('/quarantine/contractors', { params })
      .then((r) => r.data),
  summary: () =>
    api.get<QuarantineSummary>('/quarantine/summary').then((r) => r.data),
};
